import React from "react";
import "./experiencemob.scss";
import "aos/dist/aos.css";

const ExperienceMob = () => {
  return (
    <section id="experience">
      <div className="container exp-mob">
        <div className="exp-header">
          <h1 data-aos="fade-up">/Experience</h1>
        </div>

        <div className="timeline">

          {/* ITEM 1 */}
          <div className="timeline-item" data-aos="fade-right">
            <div className="timeline-marker" aria-hidden="true"></div>
            <div className="timeline-content">
              <div className="exp-header-line">
                <h2 className="experience-title">Data Scientist I</h2>
                <span className="exp-badge">Full-time</span>
              </div>
              <div className="role-title">
                <p>
                  @{" "}
                  <a href="https://www.jnj.com/" target="_blank" rel="noreferrer">
                    Johnson & Johnson Pharmaceuticals
                  </a>
                </p>
                <span className="role-location">São Paulo, Brazil</span>
              </div>
              <p className="role-time">Feb 2025 — Present</p>

              <ul className="role-description">
                <li>Developed predictive models in Python and SQL for new drug launches using PCA, clustering, regression, Random Forest, and Gradient Boosting techniques.</li>
                <li>Worked on the full machine learning lifecycle, from data exploration to integration into AWS pipelines using services such as S3, RDS, Glue, and Lambda.</li>
                <li>Implemented Git Flow and Kedro pipelines for reusable notebooks, improving code development efficiency.</li>
                <li>Conducted hypothesis testing, ANOVA, and correlation analysis to identify key performance drivers.</li>
                <li>Executed ETL processes with SQL and Python, including deduplication, null treatment, and data normalization.</li>
                <li>Created interactive dashboards using Power BI, Matplotlib, Seaborn, and Plotly, translating results into actionable insights for stakeholders.</li>
                <li>Collaborated with cross-functional teams (product, engineering, and business) to solve complex problems and support data-driven decision-making.</li>
              </ul>

              <div className="tech-tags">
                <span>Python</span>
                <span>SQL</span>
                <span>AWS</span>
                <span>Kedro</span>
                <span>Power BI</span>
                <span>Machine Learning</span>
              </div>
            </div>
          </div>

          {/* ITEM 2 */}
          <div className="timeline-item" data-aos="fade-right">
            <div className="timeline-marker"></div>
            <div className="timeline-content">
              <div className="exp-header-line">
                <h2 className="experience-title">Data Analysis Intern</h2>
                <span className="exp-badge">Internship</span>
              </div>
              <div className="role-title">
                <p>
                  @{" "}
                  <a href="https://www.jnj.com/" target="_blank" rel="noreferrer">
                    Johnson & Johnson Pharmaceuticals
                  </a>
                </p>
                <span className="role-location">Remote</span>
              </div>
              <p className="role-time">Jun 2024 — Feb 2025</p>

              <ul className="role-description">
                <li>Participated in an intensive IT bootcamp focused on Python, SQL, AI, and Data Engineering, applying ETL, data modeling, and analytical visualization concepts.</li>
                <li>Structured SQL queries in Databricks and DBeaver for extraction, transformation, and analysis, ensuring efficiency, integrity, and reliability.</li>
                <li>Developed automations and dashboards in Power BI, connecting multiple data sources to generate strategic insights for business decision-making.</li>
              </ul>

              <div className="tech-tags">
                <span>Python</span>
                <span>SQL</span>
                <span>Databricks</span>
                <span>Power BI</span>
              </div>
            </div>
          </div>

          {/* ITEM 3 */}
          <div className="timeline-item" data-aos="fade-right">
            <div className="timeline-marker"></div>
            <div className="timeline-content">
              <div className="exp-header-line">
                <h2 className="experience-title">Software Engineering Intern</h2>
                <span className="exp-badge">Internship</span>
              </div>
              <div className="role-title">
                <p>
                  @{" "}
                  <a href="https://embraer.com/br/pt" target="_blank" rel="noreferrer">
                    Embraer
                  </a>
                </p>
                <span className="role-location">Remote</span>
              </div>
              <p className="role-time">Jan 2023 — Jun 2024</p>

              <ul className="role-description">
                <li>Refactored the Front-End of Fly Embraer, a platform with over 100,000 users, enhancing usability with PHP, JavaScript, Unit Testing, and quality monitoring using quantitative metrics.</li>
                <li>Fixed bugs in One Place, an internal system with 20,000 users, ensuring stability and reliability using TypeScript, Next.js, Java, and database integration in an Agile Scrum environment.</li>
                <li>Executed SQL queries for data extraction, transformation, and validation during SAP system migration, ensuring data integrity and consistency.</li>
              </ul>

              <div className="tech-tags">
                <span>TypeScript</span>
                <span>Next.js</span>
                <span>Java</span>
                <span>SQL</span>
                <span>PHP</span>
                <span>Agile</span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ExperienceMob;
